import { Divider } from "@mui/material";
import { DisplayBox } from "components/OutputBox";
import UploadFile from "components/UploadFile";
import { BaseInput, LargeButton, OverlayLoader, Ptag } from "components/core";
import { Form, Formik } from "formik";
import React, { useMemo, useState } from "react";
import { colors } from "theme";
import {
  formatDate,
  formatToRupees,
  getFileNameFromUrl,
  newFormatRupees,
  rupeesToNumber,
} from "utlis/utils";
import * as Yup from "yup";
import "./styles.css";
import http from "services/httpService";
import { useNavigate } from "react-router";
import routes from "components/routes";
import BaseDateInput from "components/UniversalComponents/BaseDateInput";
import MultipleFileUpload from "components/UploadFile/MultipleFileUpload";

const InitialValues = {
  date: "",
  endorsNumber: "",
  premium: "",
  cgst: "",
  sgst: "",
  igst: "",
  gross_premium: "",
};

const EndorsementHistoryEdit = ({ detail }) => {
  const navigate = useNavigate();

  const [pdfId, setPdfId] = useState("");
  const [empSheet, setEmpSheet] = useState("");
  const [pdfName, setPdfName] = useState("");
  const [empSheetName, setEmpSheetName] = useState("");
  const [grossPremium, setGrossPremium] = useState("");
  const [loading, setLoading] = useState(false);
  const [wellnessIDs, setWellnessIDs] = useState([]);

  const calculateGrossPremium = (value) => {
    const cgst = Number(value?.cgst),
      igst = Number(value?.igst),
      sgst = Number(value?.sgst),
      premium = Number(value?.premium);
    const gross = (cgst + igst + sgst + premium).toString();
   setGrossPremium(gross!=0&&newFormatRupees(gross));
  };
  const endorsment = useMemo(() => {
    if (detail.type === "INCEPTION") {
      return false;
    } else {
      return true;
    }
  }, [detail]);

  const validationSchema = Yup.object().shape({
    date: Yup.string().required("Date is required"),
    endorsNumber: endorsment
      ? Yup.string().required("Endorsement Number is required")
      : "",
    premium: Yup.string().required("Premium is required"),
    cgst: Yup.string().required("CGST is required"),
    sgst: Yup.string().required("SGST is required"),
    igst: Yup.string().required("IGST is required"),
  });

  const initialValues = useMemo(() => {
    return {
      date: detail?.transaction_date || "",
      endorsNumber: detail?.endorsement_number || "",
      premium: detail?.net_premium,
      cgst: detail?.cgst,
      sgst: detail?.sgst,
      igst: detail?.igst,
    };
  }, [detail]);

  const uploadData = async (values) => {
    const payload = {
      userplan_id: detail?.userplan_id,
      document_ids: wellnessIDs?.length > 0 ? wellnessIDs : [pdfId],
      payment_date: formatDate(values?.date),
      amount: rupeesToNumber(grossPremium),
      net_premium: Number(values?.premium),
      cgst: Number(values?.cgst),
      igst: Number(values?.igst),
      sgst: Number(values?.sgst),
      order_id: detail?.order_id,
      vendor_id: detail?.vendor_id,
      employee_wise_breakup_sheet_id: empSheet,
      endorsement_number: values?.endorsNumber,
    };

    try {
      setLoading(true);
      const { data } = await http.post("/business/upload_invoice/", payload);
      navigate(`/v1/enrolments`);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return loading ? (
    <OverlayLoader />
  ) : (
    <>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={uploadData}
      >
        {(formikProps) => (
          <div style={{ marginBottom: "2.8rem" }}>
            {calculateGrossPremium(formikProps?.values)}
            <Form
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <div className="date-numeber-wrapper">
                {/* <BaseInput
                  staticLabel="Date"
                  date
                  fontSize="14px !important"
                  formikProps={{
                    ...formikProps,
                    name: "date",
                  }}
                /> */}
                <BaseDateInput
                  staticLabel="Date"
                  onlyPastDate={true}
                  formikProps={{ ...formikProps, name: "date" }}
                />
                {endorsment && (
                  <BaseInput
                    staticLabel="Endorsement Number"
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "endorsNumber",
                    }}
                  />
                )}
              </div>
              <BaseInput
                staticLabel="Net Premium"
                formatToRupee
                fontSize="14px !important"
                formikProps={{
                  ...formikProps,
                  name: "premium",
                }}
              />
              <div>
                <Ptag
                  color={colors.primaryColor}
                  fontSize="14px"
                  marginBottom="16px"
                >
                  Taxes
                </Ptag>
                <div
                  style={{
                    display: "flex",
                    gap: "4rem",
                    width: "800px",
                  }}
                >
                  <BaseInput
                    label="CGST"
                    formatToRupee
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "cgst",
                    }}
                  />
                  <BaseInput
                    label="SGST"
                    formatToRupee
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "sgst",
                    }}
                  />
                  <BaseInput
                    label="IGST"
                    formatToRupee
                    fontSize="14px !important"
                    formikProps={{
                      ...formikProps,
                      name: "igst",
                    }}
                  />
                </div>
              </div>

              <DisplayBox value={grossPremium} label="Gross Premium" />
              <MultipleFileUpload
                wellnessIDs={wellnessIDs}
                setWellnessIDs={setWellnessIDs}
              />
              {/* <UploadFile
                headerMargin="12px 0"
                label={"Upload Invoice"}
                text={"Upload File"}
                format="pdf"
                existingFileName={getFileNameFromUrl(
                  detail?.documents?.invoice_link
                )}
                type="premiums_invoice"
                onSelect={setPdfId}
                fileName={setPdfName}
              /> */}
              <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
              <UploadFile
                headerMargin="12px 0"
                label={"Employee-wise Breakup Sheet (optional)"}
                text={"Upload File"}
                existingFileName={getFileNameFromUrl(
                  detail?.documents?.employee_break_wise_link
                )}
                format="excel"
                type="employee_wise_breakup"
                onSelect={setEmpSheet}
                fileName={setEmpSheetName}
              />
              <LargeButton id="" label={"Update"} type="submit" />
            </Form>
          </div>
        )}
      </Formik>
    </>
  );
};

export default EndorsementHistoryEdit;
